/* Orléa — LE FILTRAGE DE COLLECTION, REPRIS EN MAIN

   ╔══ POURQUOI CE FICHIER EXISTE ════════════════════╗

   Simon, après quatre correctifs successifs :
   > « C'est un peu mieux, mais je pense que c'est juste du patching.
   >   Pourquoi c'est aussi compliqué ? »

   Il avait raison. LA CAUSE, lue dans le source de critical.js :

     handleFilterDrawerUpdate(url, sectionId) {
       fetch(...).then(...) => {
         document.querySelector('.filter_drawer_wrapper').innerHTML =
           temp.querySelector('.filter_drawer_wrapper').innerHTML;
       }
     }

   Flaunt remplace le CONTENEUR ENTIER du tiroir à chaque filtrage :
   l'overlay, le panneau, le formulaire, tout. Conséquences en cascade :

     • le panneau est un NOUVEAU nœud → il repart de l'état fermé
       (opacity 0, translate 5rem) : le tiroir paraît se fermer ;
     • le `mouseleave` de l'ANCIEN nœud détruit laisse le curseur custom
       bloqué sur « close » ;
     • `data-scroll-locked` reste sur le body → plus de scroll.

   🔴 Flaunt NE PRÉVOIT PAS qu'un tiroir de filtres reste ouvert. Toute
   tentative de rattraper l'état après coup est une rustine — j'en ai
   écrit trois, et Simon les a vues.

   ╚══ CE QUE FAIT CE FICHIER ══════════════════════╝

   On prend la main sur le filtrage :

     1. on intercepte le `change` d'un filtre EN CAPTURE, avant Flaunt,
        et on arrête la propagation → `handleFilterDrawerUpdate` ne
        s'exécute jamais, donc le conteneur n'est jamais détruit ;
     2. on va chercher la section rendue (?sections=<id>, l'API que
        Flaunt utilise déjà) ;
     3. on remplace la GRILLE de produits ;
     4. on remplace le CONTENU DU FORMULAIRE, dans le tiroir intact.

   Le conteneur `.filter_drawer_wrapper` n'est JAMAIS touché : sa classe
   `active`, ses écouteurs et le curseur restent valides. Il n'y a plus
   rien à remettre en état.

   ⚠ Le tiroir ne se ferme que par les trois gestes attendus : clic sur
   l'overlay, sur le X, ou sur « View N products ». La fermeture passe
   par `closeDrawer` de Flaunt — elle nettoie l'attribut ET rappelle
   `lenis.start()`, sans quoi le scroll reste mort.

   ⚠ REPLI : si l'interception échoue (structure inattendue, fetch en
   erreur), on laisse Flaunt faire son travail habituel. Un filtrage
   moche vaut mieux qu'un filtrage cassé.

   Rollback : retirer sa ligne de `orlea-filtres-css.liquid`.
*/
(function () {
  'use strict';

  var SEL_TIROIR  = '.filter_drawer_wrapper';
  var SEL_GRILLE  = '.main_collection_product_grid';
  var SEL_FORM    = '#filters_form--drawer';
  var ATTR_VERROU = 'data-scroll-locked';

  function tiroir()  { return document.querySelector(SEL_TIROIR); }
  function curseur() { return document.querySelector('.cursor_pointer'); }

  /* L'identifiant de section : Flaunt le pose sur <collection-filters>.
     On le LIT, on ne le devine pas — Shopify le régénère si le gabarit
     est recréé, et une valeur figée donnerait un 404 silencieux. */
  function idSection() {
    var e = document.querySelector('collection-filters[data-section-id], [data-section-id]');
    return e ? e.dataset.sectionId : null;
  }

  function montrerChargement(actif) {
    var t = tiroir();
    if (!t) return;
    var l = t.querySelector('.loader_wrapper');
    if (l) l.classList.toggle('active', !!actif);
  }

  /* Remplacement CIBLÉ : la grille, puis l'intérieur du formulaire.
     Jamais le conteneur du tiroir — c'est tout l'objet de ce fichier. */
  function appliquer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var grilleNeuve = doc.querySelector(SEL_GRILLE);
    var grilleVieille = document.querySelector(SEL_GRILLE);
    if (grilleNeuve && grilleVieille) {
      grilleVieille.innerHTML = grilleNeuve.innerHTML;
    }

    // Le bouton « Load more » vit hors de la grille.
    var suivNeuf = doc.querySelector('.infinite-scroll--next');
    var suivVieux = document.querySelector('.infinite-scroll--next');
    if (suivVieux && suivNeuf) {
      suivVieux.dataset.nextUrl = suivNeuf.dataset.nextUrl;
      suivVieux.hidden = false;
    } else if (suivVieux && !suivNeuf) {
      suivVieux.hidden = true;   // plus de page suivante
    }

    // Le formulaire : on remplace son CONTENU, pas le formulaire lui-même
    // (le tiroir garde ainsi son nœud et ses écouteurs).
    var formNeuf = doc.querySelector(SEL_FORM);
    var formVieux = document.querySelector(SEL_FORM);
    if (formNeuf && formVieux) {
      formVieux.innerHTML = formNeuf.innerHTML;
    }

    // Le compte de produits, affiché dans la barre de contrôle et le titre
    // du tiroir. Les deux vivent hors de la grille.
    ['.ocol-count', '.filter_drawer_header h5'].forEach(function (sel) {
      var n = doc.querySelector(sel), v = document.querySelector(sel);
      if (n && v) v.innerHTML = n.innerHTML;
    });
  }

  function filtrer(url) {
    var id = idSection();
    if (!id) return false;              // repli : on laisse Flaunt agir

    var u = new URL(url, window.location.origin);
    u.searchParams.set('sections', id);

    montrerChargement(true);

    fetch(u.toString())
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data[id]) throw new Error('section absente de la réponse');
        appliquer(data[id]);

        // L'URL visible suit le filtrage, sans recharger : le visiteur peut
        // partager le lien et le bouton Retour fonctionne.
        var propre = new URL(url, window.location.origin);
        propre.searchParams.delete('sections');
        window.history.replaceState({}, '', propre.toString());

        // Les composants Flaunt du contenu neuf doivent être réveillés.
        document.querySelectorAll('quick-add-button').forEach(function (el) {
          if (typeof el.attachEvents === 'function') el.attachEvents();
        });
      })
      .catch(function () {
        // En cas d'échec, on navigue : le filtre s'applique quand même.
        window.location.href = url;
      })
      .then(function () { montrerChargement(false); });

    return true;
  }

  /* 🔴 L'INTERCEPTION — en CAPTURE, donc avant le handler de Flaunt.
     `stopImmediatePropagation` empêche `handleFilterDrawerUpdate` de
     tourner : c'est ce qui évite la destruction du conteneur. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('filter_input')) return;
    if (!input.closest(SEL_TIROIR)) return;

    var url = input.checked ? input.dataset.addUrl : input.dataset.removeUrl;
    if (!url) return;                  // repli : Flaunt s'en occupe

    if (filtrer(url)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  /* Les jetons de filtre actif : même traitement. Ce sont des <a>, donc
     on intercepte le clic. */
  document.addEventListener('click', function (e) {
    var lien = e.target.closest && e.target.closest('a.active_filter');
    if (!lien || !lien.closest(SEL_TIROIR)) return;
    var href = lien.getAttribute('href');
    if (href && filtrer(href)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  /* Le tri (un <select>) : même logique, hors du tiroir. */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || sel.tagName !== 'SELECT' || sel.name !== 'sort_by') return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    if (filtrer(u.toString())) {
      e.stopImmediatePropagation();
    }
  }, true);

  /* FERMETURE AU CLIC SUR L'OVERLAY — absente de Flaunt (vérifié dans son
     source). En BULLE, pour ne pas voler les clics des filtres. */
  document.addEventListener('click', function (e) {
    var t = tiroir();
    if (!t || !t.classList.contains('active')) return;
    if (!t.contains(e.target)) return;
    var panneau = t.querySelector('.main_drawer_inner');
    if (panneau && panneau.contains(e.target)) return;

    if (typeof window.closeDrawer === 'function') {
      window.closeDrawer(t);           // nettoie l'attribut ET relance lenis
    } else {
      t.classList.remove('active');
      t.setAttribute('aria-hidden', 'true');
      document.body.removeAttribute(ATTR_VERROU);
      if (window.lenis && window.lenis.start) window.lenis.start();
    }
    var c = curseur();
    if (c) c.classList.remove('close');
  });
})();
